import React from 'react';

import Pic1 from '../../InstallImages/Modules/Hanwha340WBBB';


const han340link = <a href="https://www.dropbox.com/s/lotrqk2s7ql3t5f/Hanwha_Q_CELLS_Data_sheet_Q.PEAK_DUO_BLK-G6_330-345_2019-03_Rev01_NA.pdf?dl=0" rel="noopener noreferrer" target="_blank">Data Sheet</a>;

const han340Video = <a href="https://www.youtube.com/watch?v=s2819HrRGrM" rel="noopener noreferrer" target="_blank">Video: QCell Technology Overview</a>;

const Module = () => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">

            <p className="specsText">
                The new Q.PEAK DUO BLK-G6 solar module from Q CELLS impresses with its outstanding visual appearance and particularly high performance on a small surface thanks to the innovative Q.ANTUM DUO Technology. Q.ANTUM&#39;s world-record-holding cell concept has now been combined with state-of-the-art circuitry half cells and a six-busbar design, thus achieving outstanding performance under real conditions — both with low-intensity solar radiation as well as on hot, clear summer days.
            </p>
            <ul> <h1>Key Features</h1>
                <li className="specsText">Higher yield per surface area, lower BOS costs, higher power classes, and an efficiency rate of up to 19.5 %.</li>
                <li className="specsText">Optimal yields, whatever the weather with excellent low-light and temperature behavior.</li>
                <li className="specsText">Long-term yield security with Anti LID and Anti PID Technology, Hot-Spot Protect and Traceable Quality Tra.Q.</li>
                <li className="specsText">High-tech aluminum alloy frame, certified for high snow (5400 Pa) and wind loads (4000 Pa) regarding IEC.</li>
                <li className="specsText">Inclusive 12-year product warranty and 25-year linear performance guarantee</li>
                <li className="specsText"> Q.ANTUM DUO combines cutting edge cell separation and innovative wiring with Q.ANTUM Technology</li>
                <li className="specsText">{han340Video}</li>
                <li className="specsText">{han340link}</li>
            </ul>
        </div>
    </div>
);

export default Module;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Panels/han340.js